module.exports = __webpack_public_path__ + "img/faceRecognition.b5a9b690.png";